import { render, staticRenderFns } from "./CommonChart.vue?vue&type=template&id=b1bffb4a&scoped=true"
import script from "./CommonChart.vue?vue&type=script&lang=js"
export * from "./CommonChart.vue?vue&type=script&lang=js"
import style0 from "./CommonChart.vue?vue&type=style&index=0&id=b1bffb4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bffb4a",
  null
  
)

export default component.exports